import * as React from 'react'
import { styled } from "styled-components"
import { I18nService } from '../../services/utils/i18n.service'

const HomonymTag = styled.span`
  font-size: 0.6rem;
  background: #1b00ff47;
  line-height: 1rem;
  padding: 0.2rem 0.5rem;
  border-radius: 10px;
  color: white;
`

const i18nScoped = new I18nService(require('./homonym-tag.component.yml'))

export default function HomonymTagComponent ({ className }: { className?: string }) {
  return <HomonymTag className={ className }>{ i18nScoped.t('homonym') }</HomonymTag>
}
